import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cuit',
})
export class CuitPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    let cuitValue: string = String(value);

    let cuitArray = cuitValue.split('');

    let cuit: string;

    if (cuitArray.length === 11) {
      cuit = `${cuitArray.slice(0, 2)}-${cuitArray.splice(2, 8)}-${
        cuitArray[cuitArray.length - 1]
      }`.replaceAll(',', '');
    } else {
      cuit = `${cuitArray.slice(0, 2)}-${cuitArray.splice(2, 7)}-${
        cuitArray[cuitArray.length - 1]
      }`.replaceAll(',', '');
    }

    return cuit;
  }
}
